import React from "react";
import { Switch } from "@headlessui/react";

function Toggle(props: { title: string; checked: boolean; onChange: any }) {
  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-xs mx-auto">
        <Switch.Group as="div" className="flex items-center space-x-4">
          <Switch
            as="button"
            checked={props.checked}
            onChange={props.onChange}
            className={`${
              props.checked ? "bg-prismade-blue" : "bg-white"
            } relative inline-flex flex-shrink-0 h-6 transition-colors duration-200 ease-in-out border-2 border-prismade-blue rounded-full cursor-pointer w-11 focus:outline-none focus:shadow-outline`}
          >
            {({ checked }) => (
              <span
                className={`${
                  checked
                    ? "translate-x-5 bg-white"
                    : "translate-x-0 bg-prismade-blue border border-white"
                } inline-block w-5 h-5 transition duration-200 ease-in-out transform rounded-full`}
              />
            )}
          </Switch>
          <Switch.Label>
            <span className="text-gray-900">{props.title}</span>
          </Switch.Label>
        </Switch.Group>
      </div>
    </div>
  );
}

export default Toggle;
